<template>
	<div>
		<header-vue></header-vue>
		<div class="container-l2 container-l4">
			<h1 class="h11">动环批量阈值</h1>
			<div class="side-nav h500">
				<ul class="">
					<li @click="chageActiveType(typeItem,typeIndex)" :class="{'active':activeTypeIndex==typeIndex}" v-for="(typeItem,typeIndex) in devTypes">
						<a href="javascript:void(0);" v-text="typeItem.cn_name"></a>
					</li>
				</ul>
				
			</div>
			
			<div class="clear mt20 ml10">
				<div class="secNav">
					<ul>
						<li @click="chageActiveShre(shreItem,shreIndex)" :class="{active:activeShreIndex==shreIndex}" v-for="(shreItem,shreIndex) in shresholdList">
				            <a v-text="shreItem.cn_name" href="javascript:void(0);"></a>
				          </li>
					</ul>
				</div>
				
				<div class="znjg-box" v-if="shreDetail && shreDetail.cn_name">
					<hr />
					<div class="width2 ml20">
						<el-form :model="shreDetail" label-width="100px">
						  	<el-form-item v-if="shreDetail.cn_name" label="变量名称：">
						  		<span v-text="shreDetail.cn_name"></span>
						    </el-form-item>
						    <el-form-item label="告警值："  v-if='shreDetail.data_tag'>
						    	<el-input v-model="shreDetail.alarm_content"  :placeholder="GetChinese(shreDetail.data_tag)" auto-complete="off"></el-input>
						    </el-form-item>
						    <el-form-item label="橙色下限："  v-if='!shreDetail.data_tag'>
						    	<el-input v-model="shreDetail.orange_lower" auto-complete="off"></el-input>
						    </el-form-item>
						    <el-form-item label="红色下限："  v-if='!shreDetail.data_tag'>
						    	<el-input v-model="shreDetail.red_lower" auto-complete="off"></el-input>
						    </el-form-item>
						    <el-form-item label="橙色上限："  v-if='!shreDetail.data_tag'>
						    	<el-input v-model="shreDetail.orange_upper" auto-complete="off"></el-input>
						    </el-form-item>
						    <el-form-item label="红色上限："  v-if='!shreDetail.data_tag'>
						    	<el-input v-model="shreDetail.red_upper" auto-complete="off"></el-input>
						    </el-form-item>
						</el-form>
						<div class="text-center">
							<el-button class="btn btn-primary" @click="saveVar()">保 存</el-button>
						</div>
					</div>
					
				</div>
				<div v-if="!shreDetail || !shreDetail.cn_name">
					<hr />
					<br />
					<br />
					<br />
					<p>数据异常！</p>
				</div>
			
				
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		mounted() {
			this.$nextTick(function(){
				this.getTypes();
		  	})
			

			
    	},
    	data(){
    		return{
    			comList:[],
    			selectComId:this.getCookie('company_id'),
    			selectCom:{},
    			selectAreaId:null,
    			administrators:this.getCookie('administrators'),
    			devTypes:[],
    			activeTypeIndex:0,
    			activeType:{},
    			shresholdList:[],
    			activeShreshold:{},
    			activeShreIndex:0,
    			shreDetail:{}
    		}
    	},
    	methods:{

    		getTypes(){
    			let valiCodeParams={
					uid:this.getCookie('uid'),
					company_id:this.selectComId,
					packet_id:this.selectAreaId || -1,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/MoveDeviceQuery/MoveDeviceTypePLQuery",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		this.devTypes = res.data.data;
		        		this.activeType = this.devTypes[0] || {};
		        		this.getShresholdList();
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
    		},
//  		点击类型
    		chageActiveType(item,index){
    			this.activeShreIndex = 0;
    			this.activeType = item;
    			this.activeTypeIndex = index;
    			this.getShresholdList();
    		},
//  		获取对应类型的变量列表
    		getShresholdList(){
    			let valiCodeParams={
					uid:this.getCookie('uid'),
					product_id:this.activeType.id,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/MoveDeviceQuery/ThresholdQuery",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		this.shresholdList = res.data.data;
		        		this.activeShreshold = this.shresholdList[0] || [];
		        		this.getShreDetail();
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
    		},
    		chageActiveShre(item,index){
    			this.activeShreshold = item;
    			this.activeShreIndex = index;
    			this.getShreDetail();
    		},
    		getShreDetail(){
    			let valiCodeParams={
					uid:this.getCookie('uid'),
					company_id:this.selectComId,
					datadictionary_id:this.activeShreshold.id,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/MovePLThreshold/MovePLThresholdDetail",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		this.shreDetail = res.data.data || {};
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
    		},
    		saveVar(){
    			let editShreParams={
					uid:this.getCookie('uid'),
					company_id:this.selectComId,
					datadictionary_id:this.activeShreshold.id,
					alarm_content: this.shreDetail.alarm_content || "",
					red_upper: this.shreDetail.red_upper,
					orange_upper: this.shreDetail.orange_upper,
					red_lower: this.shreDetail.red_lower,
					orange_lower: this.shreDetail.orange_lower,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(editShreParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/MovePLThreshold/MovePLThresholdEdt",this.$qs.stringify(editShreParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	
		        	if(res.data.code==200){
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        		//console.log(res.data.msg);
		        	}
		  		});
    		},
    		
    	}
   }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/alarm/envThresholdBatch.vue